import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private authService: AuthService, private permissionService: PermissionService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const currentUser = this.authService.currentUserValue;
    if (currentUser) {
      const anyPermissions = route.data['anyPermissions'] as string[] | undefined;
      if (anyPermissions?.length && !this.permissionService.hasAny(anyPermissions)) {
        return this.router.parseUrl(this.permissionService.getLandingRoute());
      }
      const permission = route.data['permission'] as string | undefined;
      if (permission && !this.permissionService.has(permission)) {
        return this.router.parseUrl(this.permissionService.getLandingRoute());
      }

      if (route.data['adminOnly'] === true && !this.permissionService.isAdmin()) {
        return this.router.parseUrl(this.permissionService.getLandingRoute());
      }

      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.authService.logout();
    return false;
  }
}
